<template>
    <div>
      <PageLoader :storage="appLoading" />
      <ServerError v-if="ServerError" />
      <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
        <v-layout wrap justify-center>
          <v-flex text-left class="align-self-center">
            <span style="color: #fff">{{ msg }}</span>
          </v-flex>
          <v-flex text-right>
            <v-btn small :ripple="false" text @click="showSnackBar = false">
              <v-icon style="color: #fff">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-snackbar>
      <v-layout wrap justify-center class="rm-list-container pa-6">
        <v-flex xs12>
          <!-- ══ FILTERS CONTAINER ══ -->
          <div class="filter-card mb-6">
            <v-row align="center" class="ma-0">
              <v-col cols="12" sm="4" md="3" class="py-2 px-3">
                <span class="filter-label">District</span>
                <v-select
                  outlined
                  hide-details
                  placeholder="All Districts"
                  dense
                  :items="districts"
                  v-model="district"
                  color="#14532D"
                  class="custom-select"
                />
              </v-col>
              <v-col cols="12" sm="4" md="4" class="py-2 px-3">
                <span class="filter-label">Search Keyword</span>
                <v-text-field
                  outlined
                  hide-details
                  placeholder="Search Name/Phone/Code"
                  dense
                  v-model="keyword"
                  color="#14532D"
                  class="custom-select"
                  clearable
                />
              </v-col>
              <v-col cols="12" sm="4" md="5" class="py-2 px-3 text-right">
                <v-btn
                  v-if="selectedItems.length > 0"
                  color="#D97706"
                  dark
                  depressed
                  @click="bulkRevokeDialog = true"
                >
                  <v-icon left>mdi-swap-horizontal</v-icon>
                  Bulk Revoke ({{ selectedItems.length }})
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <!-- ══ TABLE CONTAINER ══ -->
          <v-layout wrap justify-start pt-2 v-if="userlist && userlist.length > 0">
            <v-flex xs12>
              <v-card class="custom-table-card elevation-0">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-center" style="width: 50px;">
                          <v-checkbox
                            v-model="selectAll"
                            color="#14532D"
                            hide-details
                            class="ma-0 pa-0"
                            @change="toggleSelectAll"
                          ></v-checkbox>
                        </th>
                        <th class="text-left">Rescuer Code</th>
                        <th class="text-left">Name</th>
                        <th class="text-left">Phone</th>
                        <th class="text-left">Email</th>
                        <th class="text-left">District</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in userlist"
                        :key="index"
                        class="clickable-row"
                        @click="openviewdetails(item)"
                      >
                        <td @click.stop class="text-center">
                          <v-checkbox
                            v-model="selectedItems"
                            :value="item._id"
                            color="#14532D"
                            hide-details
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </td>
                        <td class="font-weight-medium">
                          <span v-if="item && item.rescuerCode">{{ item.rescuerCode }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td class="font-weight-bold" style="color: #1E293B;">
                          <span v-if="item && item.user && item.user.name">{{ item.user.name }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td>
                          <span v-if="item && item.user && item.user.phone">{{ item.user.phone }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td>
                          <span v-if="item && item.user && item.user.email">{{ item.user.email }}</span>
                          <span v-else class="text-muted">-</span>
                        </td>
                        <td>
                          <v-chip small color="rgba(20,83,45,0.08)" text-color="#14532D" class="font-weight-medium">
                            {{ (item && item.district) ? item.district : '-' }}
                          </v-chip>
                        </td>
                        <td class="text-center" @click.stop>
                          <div class="d-flex align-center justify-center action-group">
                            <!-- Edit Details -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <button
                                  class="action-btn action-btn--edit"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="openeditdetails(item)"
                                >
                                  <v-icon size="16">mdi-pencil</v-icon>
                                </button>
                              </template>
                              <span>Edit Rescuer</span>
                            </v-tooltip>

                            <!-- Revoke Suspension -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <button
                                  class="action-btn action-btn--revoke"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="revokeDialog(item._id)"
                                >
                                  <v-icon size="16">mdi-swap-horizontal</v-icon>
                                </button>
                              </template>
                              <span>Revoke Suspension</span>
                            </v-tooltip>

                            <!-- Delete Rescuer -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <button
                                  class="action-btn action-btn--delete"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="rejectDialog(item.user._id)"
                                >
                                  <v-icon size="16">mdi-delete</v-icon>
                                </button>
                              </template>
                              <span>Delete</span>
                            </v-tooltip>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 pb-4 v-if="userlist && userlist.length > 0">
          <v-layout wrap justify-center>
            <v-flex xs10>
              <v-pagination
                v-model="currentPage"
                :length="Pagelength"
                :total-visible="7"
                circle
                color="#14532D"
                small
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-else>
          <v-layout wrap justify-start pl-5>
            <v-flex xs12 class="text-left">
              <span class="heading">No Data Found!</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-dialog v-model="bulkRevokeDialog" max-width="500">
        <v-card>
          <v-card-title class="heading">Confirm Bulk Revoke</v-card-title>
          <v-card-text>
            Are you sure you want to revoke the suspension for {{ selectedItems.length }} selected rescuers?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              tile
              outlined
              color="#FF1313"
              light
              :ripple="false"
              depressed
              @click="bulkRevokeDialog = false"
              class="itemValue"
            >
              Cancel
            </v-btn>
            <v-btn
              tile
              :color="appColor"
              light
              :ripple="false"
              depressed
              @click="bulkSuspendUser()"
              class="itemValue"
            >
              <span style="color: #fff">Confirm</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" max-width="500">
        <v-card>
          <v-card-title class="heading">Delete Rescuer</v-card-title>
          <v-card-text>
            Are you sure you want to delete this rescuer?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              tile
              outlined
              color="#FF1313"
              light
              :ripple="false"
              depressed
              @click="deleteDialog = false"
              class="itemValue"
            >
              Cancel
            </v-btn>
            <v-btn
              tile
              :color="appColor"
              light
              :ripple="false"
              depressed
              @click="deleteUser()"
              class="itemValue"
            >
              <span style="color: #fff">Confirm</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="restrictDialog" max-width="500">
        <v-card>
          <v-card-title class="heading">Confirmation</v-card-title>
          <v-card-text>
            Are you sure you want to revoke the suspension of this rescuer?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              tile
              outlined
              color="#FF1313"
              light
              :ripple="false"
              depressed
              @click="restrictDialog = false"
              class="itemValue"
            >
              Cancel
            </v-btn>
            <v-btn
              tile
              :color="appColor"
              light
              :ripple="false"
              depressed
              @click="suspendUser()"
              class="itemValue"
            >
              <span style="color: #fff">Confirm</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
        <script>
  import axios from "axios";
  export default {
    data() {
      const pageKey = this.$route.name || 'defaultPage';
      return {
        appLoading: false,
        ServerError: false,
        showSnackBar: false,
        timeout: 5000,
        msg: null,
        count: 20,
        district: "",
        keyword: "",
        pageKey,
        currentPage: parseInt(localStorage.getItem(`${pageKey}_currentPage`)) || 1,
        Pagelength: 0,
        userlist: [],
        selectedItems: [],
        selectAll: false,
        bulkRevokeDialog: false,
        restrictDialog: false,
        districts: [
          "All",
          "Palakkad",
          "Alappuzha",
          "Malappuram",
          "Kannur",
          "Wayanadu",
          "Kozhikode",
          "Thrissur",
          "Thiruvananthapuram",
          "Kottayam",
          "Idukki",
          "Ernakulam",
          "Kollam",
          "Pathanamthitta",
          "Kasaragod",
        ],
        deleteDialog: false,
        suspendid: null,
      };
    },
    beforeMount() {
      this.getData();
    },
    watch: {
      currentPage(newVal) {
        localStorage.setItem(`${this.pageKey}_currentPage`, newVal);
        this.getData();
      },
      count() {
        this.getData();
      },
      district() {
        this.getData();
        this.currentPage = 1;
      },
      keyword() {
        this.getData();
        this.currentPage = 1;
      },
    },
    methods: {
      toggleSelectAll(val) {
        if (val) {
          this.selectedItems = this.userlist.map(item => item._id);
        } else {
          this.selectedItems = [];
        }
      },
      openviewdetails(item) {
        this.$router.push({
          path: "/rescuerslistview",
          query: {
            id: item._id,
          },
        });
      },
      rejectDialog(item) {
        this.deleteDialog = true;
        this.deleteid = item;
      },
      revokeDialog(item) {
        this.restrictDialog = true;
        this.suspendid = item;
      },
      openeditdetails(item) {
        this.$router.push({
          path: "/newrescuerslistedit",
          query: {
            id: item.user._id,
          },
        });
      },
      deleteUser() {
        this.appLoading = true;
        axios({
          method: "DELETE",
          url: "/user/delete",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            id: this.deleteid,
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              {
                this.msg = "Deleted Successfully.";
                this.showSnackBar = true;
                this.appLoading = false;
                this.deleteDialog = false;
                this.getData();
              }
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
              this.deleteDialog = false;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            (this.ServerError = true), console.log(err);
          });
      },
      suspendUser() {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/rescuer/suspendrescuer",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            id: this.suspendid,
            isSuspended: false,
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              {
                this.msg = "Revoked Successfully.";
                this.showSnackBar = true;
                this.appLoading = false;
                this.restrictDialog = false;
                this.getData();
              }
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
              this.restrictDialog = false;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            (this.ServerError = true), console.log(err);
          });
      },
      bulkSuspendUser() {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/rescuer/bulksuspendrescuer",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            ids: this.selectedItems,
            isSuspended: false,
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              this.msg = "Revoked Successfully.";
              this.showSnackBar = true;
              this.appLoading = false;
              this.bulkRevokeDialog = false;
              this.getData();
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
              this.bulkRevokeDialog = false;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      },
      getData() {
        this.appLoading = true;
        axios({
          method: "GET",
          url: "/rescuer/suspendedlist",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          params: {
            count: this.count,
            page: this.currentPage,
            district: this.district,
            keyword: this.keyword,
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              {
                this.userlist = response.data.data;
                this.Pagelength = response.data.pages;
                this.selectedItems = [];
                this.selectAll = false;
                this.appLoading = false;
              }
            } else {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            (this.ServerError = true), console.log(err);
          });
      },
    },
  };
  </script>
      <style scoped>
/* ── Filter Card ── */
.filter-card {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  padding: 12px 6px;
}
.filter-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748B;
  margin-bottom: 6px;
  padding-left: 2px;
}

/* ── Custom Inputs ── */
.custom-select ::v-deep .v-input__control > .v-input__slot {
  background: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}
.custom-select ::v-deep .v-input__control > .v-input__slot:hover {
  border-color: #CBD5E1 !important;
  background: #F1F5F9 !important;
}

/* ── Table Card ── */
.custom-table-card {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.03) !important;
  background: #FFFFFF;
}

/* Table layout styling */
.custom-table-card ::v-deep table {
  border-collapse: collapse;
  width: 100%;
}
.custom-table-card ::v-deep thead {
  background-color: #F8FAFC;
}
.custom-table-card ::v-deep th {
  height: 48px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.06em !important;
  color: #64748B !important;
  text-transform: uppercase !important;
  border-bottom: 2px solid #F1F5F9 !important;
  padding: 0 16px !important;
}
.custom-table-card ::v-deep td {
  height: 58px !important;
  font-size: 13px !important;
  color: #334155 !important;
  border-bottom: 1px solid #F1F5F9 !important;
  padding: 0 16px !important;
}

/* ── Clickable Rows ── */
.clickable-row {
  cursor: pointer;
  transition: background-color 0.18s ease;
}
.clickable-row:hover {
  background-color: #F3F7F4 !important;
}
.clickable-row:active {
  background-color: #EBF2ED !important;
}
.text-muted {
  color: #94A3B8;
}

/* ── Action buttons ── */
.action-group {
  gap: 8px;
}
.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.action-btn:hover {
  transform: scale(1.08);
}
.action-btn--edit {
  background: rgba(20, 83, 45, 0.06);
  color: #16A34A !important;
}
.action-btn--edit:hover {
  background: rgba(20, 83, 45, 0.12);
  color: #14532D !important;
}
.action-btn--revoke {
  background: rgba(217, 119, 6, 0.06);
  color: #D97706 !important;
}
.action-btn--revoke:hover {
  background: rgba(217, 119, 6, 0.12);
  color: #B45309 !important;
}
.action-btn--delete {
  background: rgba(220, 38, 38, 0.06);
  color: #DC2626 !important;
}
.action-btn--delete:hover {
  background: rgba(220, 38, 38, 0.12);
  color: #991B1B !important;
}

/* ── Empty State ── */
.empty-state {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px dashed #E2E8F0;
}
</style>
